import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Layout, Menu, Typography } from 'antd';
import './layout.css';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMenu, setOpenKeys } from '../../redux';
import { RiCalendar2Line, RiMenuFoldLine, RiMenuUnfoldLine } from 'react-icons/ri'
import moment from 'moment';
import { UserProfile } from './userProfile';
import { Scrollbars } from 'react-custom-scrollbars';
import CFG from '../../config/env';
const { Header, Content, Footer, Sider } = Layout;
const { Title, BaseColor } = CFG;
const defaultBaseColor = '#001529';
const { Text } = Typography;

export const SiderLayout = ({ children, menus, title, theme, headerBgColor, headerColor }) => {
    const { selectedMenu, openKeys } = useSelector(state => state.nav);
    const { userdata } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const [colapsed, setColapsed] = useState(false);
    const [now, setNow] = useState(moment());
    const rootSubmenuKeys = useMemo(() => {
        return menus.map(({ key }) => key);
    }, [menus]);
    useEffect(() => {
        const timer = setInterval(() => setNow(moment()), 1000);
        return () => clearInterval(timer);
    }, []);
    const renderThumbVertical = useCallback(({ style }) => (
        <div
            className='app-scrollbar__thumb'
            style={{
                ...style,
                borderRadius: 10,
                right: 4,
                width: 8,
                background: 'linear-gradient(rgb(167 72 64) 0%, rgba(11, 54, 43, 0.75) 100%)',
                opacity: 0.85
            }}
        />
    ), []);
    const renderTrackVertical = useCallback(({ style }) => (
        <div
            className='app-scrollbar__track'
            style={{
                ...style,
                borderRadius: 12,
                right: 2,
                width: 12,
                bottom: 4,
                top: 4,
                background: 'rgba(255, 255, 255, 0.08)'
            }}
        />
    ), []);
    const renderView = useCallback(({ style }) => (
        <div
            style={{ ...style, paddingRight: 6 }}
            className='app-scrollbar__view'
        />
    ), []);
    const handleToggleCollapse = () => setColapsed(prev => !prev);
    const latestTimeLabel = useMemo(() => now.format('ddd, DD MMM YYYY HH:mm'), [now]);
    const effectiveTitle = title || Title;
    const baseColor = BaseColor || defaultBaseColor;
    const siderBackground = useMemo(() => `linear-gradient(180deg, ${baseColor} 0%, #001020 100%)`, [baseColor]);
    const isDarkTheme = useMemo(() => (theme || 'dark') === 'dark', [theme]);
    const effectiveHeaderBg = headerBgColor || (isDarkTheme ? '#0b1d33' : '#ffffff');
    const effectiveHeaderColor = headerColor || (isDarkTheme ? '#f3f6fb' : '#1f1f1f');
    const contentOffset = colapsed ? 92 : 280;
    const headerStyle = useMemo(() => ({
        backgroundColor: 'white',
        color: effectiveHeaderColor,
        width: `calc(100% - ${contentOffset}px)`,
        zIndex: 99,
        position: 'fixed',
        top: 0,
        left: contentOffset,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 28px',
        height: 72
    }), [contentOffset, effectiveHeaderBg, effectiveHeaderColor]);
    const headerClassName = useMemo(() => `site-layout-sub-header-background app-header ${isDarkTheme ? 'app-header--dark' : 'app-header--light'}`, [isDarkTheme]);
    const headerIcon = colapsed ? <RiMenuUnfoldLine className='trigger' onClick={handleToggleCollapse} /> : <RiMenuFoldLine className='trigger' onClick={handleToggleCollapse} />;
    return (
        <Layout hasSider className='sider-layout'>
            <Sider
                className={`app-sider ${colapsed ? 'app-sider--collapsed' : ''}`}
                style={{ height: '100vh', position: 'fixed', top: 0, bottom: 0, left: 0, background: siderBackground }}
                breakpoint="lg"
                theme={theme || 'dark'}
                collapsed={colapsed}
                collapsedWidth={92}
                width={280}
            >
                <div className='app-sider__container'>
                    <div className='app-sider__brand'>
                        <div className='app-sider__logo'>
                            <img src={'/images/iacas.png'} alt="Logo PT" />
                        </div>
                        {!colapsed && (
                            <div className='app-sider__brand-text'>
                                <Text className='app-sider__product'>IACAS</Text>
                                <Text className='app-sider__descriptor'>Terminal Cargo</Text>
                            </div>
                        )}
                    </div>
                    <Scrollbars
                        renderThumbVertical={renderThumbVertical}
                        renderTrackVertical={renderTrackVertical}
                        renderView={renderView}
                        autoHide
                        autoHideTimeout={260}
                        autoHideDuration={200}
                        className='app-sider__scroll'
                    >
                        <Menu
                            mode="inline"
                            selectedKeys={[selectedMenu]}
                            theme={theme || 'dark'}
                            items={menus || []}
                            onClick={e => {
                                dispatch(setSelectedMenu(e.key));
                            }}
                            openKeys={openKeys}
                            onOpenChange={keys => {
                                const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
                                if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                                    dispatch(setOpenKeys(keys));
                                } else {
                                    dispatch(setOpenKeys(latestOpenKey ? [latestOpenKey] : []));
                                }
                            }}
                        />
                    </Scrollbars>
                    <div className={`app-sider__meta ${colapsed ? 'app-sider__meta--collapsed' : ''}`}>
                        <div className='app-sider__meta-icon'>
                            <RiCalendar2Line />
                        </div>
                        {!colapsed && (
                            <div className='app-sider__meta-info'>
                                <Text className='app-sider__meta-title'>Operasional</Text>
                                <Text className='app-sider__meta-time'>{latestTimeLabel}</Text>
                            </div>
                        )}
                    </div>
                </div>
            </Sider>
            <Layout style={{ marginLeft: contentOffset, minHeight: '100vh' }}>
                <Header className={headerClassName} style={headerStyle}>
                    <div className='app-header__left'>
                        {headerIcon}
                        <Typography.Title level={4} className='app-header__title'>
                            {effectiveTitle}
                        </Typography.Title>
                    </div>
                    <div className='app-header__right'>
                        <UserProfile isColapsed={colapsed} username={userdata?.username} level={userdata?.levelStr} />
                    </div>
                </Header>
                <Content style={{ margin: '96px 24px 24px', display: 'flex', flexDirection: 'column', minHeight: `calc(90% - 80px)` }}>
                    <div className="site-layout-background" style={{ padding: 24, flexGrow: 1, borderRadius: 12, boxShadow: '0 12px 30px -20px rgba(15, 31, 53, 0.45)' }}>
                        {children}
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center', height: 50, paddingTop: 14 }}>
                    COPYRIGHT © {moment().format("YYYY")} <a target={'_blank'} href="https://edifly-si.com/">Edifly Solusi Indonesia</a>, All rights Reserved
                </Footer>
            </Layout>
        </Layout>
    )
}
